/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NewAutoTestResultPermissionsParser = 
/* #__PURE__ */ parsers.object([
    ['view', codecBoolean],
    ['viewHiddenResult', codecBoolean, 'view_hidden_result'],
    ['viewHiddenOutput', codecBoolean, 'view_hidden_output'],
]);
export class NewAutoTestResultPermissions extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewAutoTestResultPermissionsParser.decode(input).map(res => new NewAutoTestResultPermissions(res));
    }
    static unsafeDecode(input) {
        return NewAutoTestResultPermissions.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewAutoTestResultPermissionsParser.encode(data);
    }
    static schema() {
        return NewAutoTestResultPermissionsParser.schema();
    }
}
